import React, { useState } from "react";

const Faq = () => {
  const questionsAndAnswer = [
    {
      question: "What is your blog website about?",
      answer:
        "Our blog website covers a wide range of topics, including but not limited to technology, lifestyle, health and wellness, finance, travel, and more. We aim to provide informative and engaging content that caters to various interests and preferences.",
    },
    {
      question: "How frequently do you publish new blog posts?",
      answer:
        "We strive to publish new blog posts regularly to keep our readers engaged and informed. Typically, we aim for at least [insert frequency here] new posts per week.",
    },
    {
      question: "Can I contribute to your blog as a guest writer?",
      answer:
        "Absolutely! We welcome guest contributions from writers who can offer unique perspectives and valuable insights. If you're interested in becoming a guest writer, please visit our Write for Us page for more information on submission guidelines and requirements.",
    },
    {
      question: "Are your blog posts free to access?",
      answer:
        "Yes, all of our blog posts are completely free to access. We believe in sharing knowledge and information openly with our audience.",
    },
    {
      question: "Do you accept sponsored content or advertisements?",
      answer:
        "Yes, we do accept sponsored content and advertisements, but we are selective about the brands and products we promote. Our priority is to maintain the integrity and quality of our content while also providing value to our readers. If you're interested in partnering with us for sponsored content or advertising opportunities, please contact our team for further details.",
    },
    {
      question: "How can I stay updated with your latest blog posts?",
      answer:
        "You can stay updated with our latest blog posts by subscribing to our newsletter or by following us on our social media channels. We also recommend bookmarking our website and checking back regularly for new content.",
    },
    {
      question:
        "Can I share your blog posts on my own website or social media?",
      answer:
        "Yes, you are welcome to share our blog posts on your own website or social media channels, as long as you provide proper credit and link back to the original post on our website. We appreciate your support in helping us reach a wider audience.",
    },
    {
      question: "Do you offer any interactive features on your blog website?",
      answer:
        "Yes, we offer various interactive features such as commenting, liking, and sharing options on our blog posts. We encourage our readers to engage with our content and share their thoughts and feedback with us and other readers.",
    },
    {
      question:
        "How can I contact you if I have further questions or feedback?",
      answer:
        "If you have any further questions, feedback, or inquiries, please don't hesitate to contact us via email at alijutt030627@gmail.com or through our contact form on the website. We value your input and strive to provide the best possible experience for our readers.",
    },
  ];
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return (
    <>
      <div class="relative mx-auto w-full py-16 px-5 font-sans text-gray-800 sm:px-20 md:max-w-screen-lg lg:py-24">
        <h2 class="mb-5 text-center font-sans text-4xl sm:text-5xl font-bold underline underline-offset-4 ">
          Frequently asked Questions
        </h2>
        <p class="mb-12 text-center text-lg text-gray-600">
          We have written down answers to some of the frequently asked
          questions. But, if you still have any queries, feel free to ping us on
          chat.
        </p>
        <ul class="space-y-4">
          {questionsAndAnswer?.map((item,index) => (
            <li key={index} class="text-left">
              <label
                for={`accordion-${index}`}
                class="relative flex flex-col rounded-md border border-gray-100 shadow-md"
              >
                <input
                  class="peer hidden"
                  type="checkbox"
                  id={`accordion-${index}`}
                  checked={openIndex === index}
                  onChange={() => handleToggle(index)}
                />
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="absolute right-0 top-4 ml-auto mr-5 h-4 text-teal-500 transition peer-checked:rotate-180"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
                <div class="relative ml-4 cursor-pointer select-none items-center py-4 pr-12">
                  <h3 class="text-sm text-gray-600 lg:text-base">
                    {item?.question}
                  </h3>
                </div>
                <div class="max-h-0 overflow-hidden transition-all duration-500 peer-checked:max-h-96">
                  <div class="p-5">
                    <p class="text-sm text-teal-600">{item?.answer}</p>
                  </div>
                </div>
              </label>
            </li>
          ))}
        </ul>
    
      </div>
    </>
  );
};

export default Faq;
